import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HOHR_COMPONENTS_TRANSLATIONS,
  setSkipInterceptorHeaders,
} from '@hohr/components';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_BASE_URL } from '../data-access/api';

@Injectable({
  providedIn: 'root',
})
export class InternationalizationService {
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Inject(HOHR_COMPONENTS_TRANSLATIONS)
    private hohrTranslations: BehaviorSubject<Record<string, string>>,
    @Optional() @Inject(API_BASE_URL) private baseUrl?: string
  ) {
    this.http = http;
  }

  getTranslations(cultureCode: string) {
    return this.http
      .get(
        `${this.baseUrl}/internationalization/culture/${cultureCode}/translation`,
        {
          ...setSkipInterceptorHeaders(true),
        }
      )
      .pipe(
        map((translations: Record<string, string>) => {
          this.hohrTranslations.next(translations);
          return translations;
        })
      );
  }
}
